import { supabase } from '../lib/supabase'

export async function obtenerCuentasFinancieras(organizacionId, { incluirInactivas = true } = {}) {
  let query = supabase.from('cp_cuentas_financieras').select('*').eq('organizacion_id', organizacionId).order('activo', { ascending: false }).order('nombre')
  if (!incluirInactivas) query = query.eq('activo', true)
  const { data, error } = await query
  if (error) throw error
  return data ?? []
}

export async function guardarCuentaFinanciera(organizacionId, values, id = null) {
  const payload = {
    organizacion_id: organizacionId,
    nombre: values.nombre.trim(),
    tipo: values.tipo,
    banco: values.tipo === 'banco' ? values.banco?.trim() || null : null,
    tipo_cuenta: values.tipo === 'banco' ? values.tipo_cuenta?.trim() || null : null,
    numero_cuenta: values.tipo === 'banco' ? values.numero_cuenta?.trim() || null : null,
    saldo_inicial: Number(values.saldo_inicial),
    fecha_saldo_inicial: values.fecha_saldo_inicial,
    activo: values.activo ?? true,
  }
  let query = id
    ? supabase.from('cp_cuentas_financieras').update(payload).eq('id', id).eq('organizacion_id', organizacionId)
    : supabase.from('cp_cuentas_financieras').insert(payload)
  const { data, error } = await query.select().single()
  if (error) throw error
  return data
}

export async function cambiarEstadoCuenta(organizacionId, id, activo) {
  const { data, error } = await supabase.from('cp_cuentas_financieras').update({ activo }).eq('id', id).eq('organizacion_id', organizacionId).select().single()
  if (error) throw error
  return data
}
